import React from "react";
import type { SearchResult } from "@elastic/search-ui";
import { Typography, Chip, Button } from "@mui/material";
import { formatBytes } from "../../utils/utils";
import { Link } from "react-router-dom";
import { viewPath } from "../../utils/routeUtils";

export interface SearchResultComponentProps {
  result: SearchResult;
  onClickLink: () => void;
}

export const SearchResultComponent: React.FC<SearchResultComponentProps> = ({
  result,
  onClickLink,
}: SearchResultComponentProps) => {
  let link = "";
  const id = btoa(result.clazz_name.raw + ":" + result.id.raw);
  if (result) {
    link = viewPath(id);
  }
  if (result.id) {
    return (
      <li className="sui-result">
        <div style={{ position: "relative", minHeight: 80 }}>
          <div className="sui-result__header">
            <Typography color="secondary">
              <strong>{result?.title?.raw || result?.file_name?.raw || result?.name?.raw || id}</strong>
            </Typography>
            {result.clazz_name && <Chip label={result.clazz_name.raw} />}
          </div>
          <div className="sui-result__body">
            <div className="sui-result__details">
              {result.file_size && (
                <Typography>
                  <strong>File Size:</strong> {formatBytes(result.file_size.raw, 2)}
                </Typography>
              )}
              {result.subtask_type && (
                <Typography>
                  <strong>Subtask Type:</strong> {result.subtask_type.raw}
                </Typography>
              )}
              {result.created && (
                <Typography>
                  <strong>Created:</strong> {new Date(result.created.raw).toLocaleString()}
                </Typography>
              )}
              {result.description && (
                <Typography sx={{ maxWidth: "85%" }}>
                  <strong>Description:</strong> {result.description.raw}
                </Typography>
              )}
            </div>
            <Button
              sx={{ height: "40%", position: "absolute", right: 30, bottom: 0 }}
              component={Link}
              to={link}
              variant="outlined"
              color="primary"
              onClick={onClickLink}
            >
              More
            </Button>
          </div>
        </div>
      </li>
    );
  }
  return <></>;
};
